const resourceService = {}

resourceService.resources = {
    subscriptions: 'subscriptions'
}

export default resourceService;